import { createSelector } from 'reselect'

const getParams = (state, props) => ({ state, props })

const getItemFields = (digitalTemplatePageItem, entities) => {
  const { digitalTemplatePageId, digitalTemplatePageItems } = entities
  const {
    id, item_type, items, options,
  } = digitalTemplatePageItem

  const { inputDataStoreKey, inputDataStoreLabel, inputRequired } = options || {}

  let fields = []

  if (item_type === 'input'){
    fields.push({
      id,
      key: inputDataStoreKey,
      label: inputDataStoreLabel,
      pageId: digitalTemplatePageId,
      required: inputRequired,
      type: item_type,
    })
  }

  if (items && items.length){
    items.forEach((itemId) => {
      const item = digitalTemplatePageItems[itemId]
      if (item){
        const itemFields = getItemFields(item, entities)
        fields = fields.concat(itemFields)
      }
    })
  }

  return fields
}

const getSectionFields = (digitalTemplatePageSection, entities) => {
  const { digitalTemplatePageItems } = entities

  let fields = []

  if (digitalTemplatePageSection.items){
    digitalTemplatePageSection.items.forEach((itemId) => {
      const item = digitalTemplatePageItems[itemId]
      if (item){
        const itemFields = getItemFields(item, entities)
        fields = fields.concat(itemFields)
      }
    })
  }

  return fields
}

const getPageFields = (digitalTemplatePage, entities) => {
  const { digitalTemplatePageSectionGroups, digitalTemplatePageSections } = entities

  let fields = []

  if (digitalTemplatePage.section_groups){
    // Section Groups
    digitalTemplatePage.section_groups.forEach((groupId) => {
      const group = digitalTemplatePageSectionGroups[groupId]
      if (group && group.sections){
        // Sections
        group.sections.forEach((sectionId) => {
          const section = digitalTemplatePageSections[sectionId]
          if (section){
            const sectionFields = getSectionFields(section, entities)
            fields = fields.concat(sectionFields)
          }
        })
      }
    })
  }

  return fields
}

const formStateSelector = createSelector(
  [getParams],
  (params) => {
    const { state, props } = params
    const { dataStoreItems, digitalTemplate } = props || {}
    const { entities } = state
    const { digitalTemplatePages } = entities

    const totalCompleted = dataStoreItems.filter(item => item.value && (!item.data || !item.data.hidden)).length
    const requiredCompleted = dataStoreItems.filter(item => item.value && (item.data && item.data.required)).length

    const formState = {
      fields: [],
      required: 0,
      requiredCompleted,
      total: 0,
      totalCompleted,
      valid: false,
    }

    if (digitalTemplate && digitalTemplate.pages){
      digitalTemplate.pages.forEach((pageId) => {
        const page = digitalTemplatePages[pageId]
        if (page){
          const pageFields = getPageFields(page, {
            ...entities,
            digitalTemplatePageId: pageId,
          })
          formState.fields = formState.fields.concat(pageFields)
          formState.total += pageFields.length
          formState.required += pageFields.filter(field => field.required).length
        }
      })
    }

    // Have all required fields been completed
    formState.valid = formState.required <= formState.requiredCompleted

    return formState
  },
)

export default formStateSelector
